export default __webpack_public_path__ + "86076703eaa55f844b0583573a30b249.svg";